export function includesSearchText(text: string, search: string): boolean {
  const normalizedSearch = search.trim().toLowerCase()
  return !normalizedSearch || text.toLowerCase().includes(normalizedSearch)
}
